export const accountManagementRouteDef = [
    // {
    //     path:':id/permissionView',
    //     component:'CustomisedFormComponent',
    //     data : {
    //         selector: 'kx-customised-form',
    //         nav_url: "permission_m"
    //     }
    // },
    // {
    //     path:':id/permission',
    //     component:'CustomisedFormComponent',
    //     data : {
    //         selector: 'kx-customised-form',
    //         nav_url: "permission_m"
    //     }
    // },
    // {
    //     path:':id/order',
    //     component:'CustomisedFormComponent',
    //     data : {
    //         selector: 'kx-customised-form',
    //         nav_url: "permission_m"
    //     }
    // },
    {
        path: 'branding-master',
        component: 'BrandingMasterComponent',
        data: {
            selector: 'app-branding-master'
        }
    },
    {
        path: 'change_loginId',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'change_loginId',
            action: 'ADD',

        }
    },
    {
        path: 'view_training_videos',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'view_training_videos',
            action: 'LIST',

        }
    },
    {
        path: 'manage_user_pin',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'manage_user_pin',
            action: 'ADD',

        }
    },
    {
        path: 'landing_url',
        component: 'LandingUrlComponent',
        data: {
            selector: 'app-landing-url',
            resource: 'landing_url',
            action: 'ADD',

        }
    },
    {
        path: 'sample',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            nav_url: "permission_m",
            action: 'ADD',
            resource: 'component_sample'
        }
    },
    {
        path: 'sample_data_grid',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            nav_url: "permission_m",
            action: 'LIST',
            resource: 'sample_data_grid'
        }
    },
    {
        path: 'sample_data_editablegrid',
        component: 'DynamicGridWithControlsComponent',
        data: {
            selector: 'kx-editable-grid',
            nav_url: "permission_m",
            action: 'EDIT_GRID',
            resource: 'sample_data_editablegrid'
        }
    },
    {
        path: ':id/resource_master',
        component: 'ViewResourceComponent',
        data: {
            selector: "kx-view-resource"
        }
    },
    // {
    //     path: ':id/bpmn/create',
    //     component: 'BpmnEngineComponent',
    //     data: {
    //         selector: 'kx-bpmn-engine'
    //     }
    // },

    {
        path: 'mapping_per_facility/:resource/:key_to_send',
        component: 'MenuRolePerFacilityComponent',
        data: {
            selector: 'app-menu-role-per-facility',
        }
    },
    {
        path: 'mapping_per_facility/:resource/:key_to_send',
        component: 'MenuRolePerFacilityComponent',
        data: {
            selector: 'app-menu-role-per-facility',
        }
    },
    {
        path: 'dashboard_master/:id',
        component: 'DashboardMasterComponent',
        data: {
            selector: 'app-dashboard-master'
        }
    },
    // {
    //     path: 'help/:identifier',
    //     component: 'HtmlViewerComponent',
    //     data: {
    //       selector: "html-viewer"
    //     }
    // },
    {
        path: 'health-card',
        component: 'HealthCardComponent',
        data: {
            selector: 'app-health-card'
        }
    },
    {
        path: 'registartion-art-form/:ivf_no',
        component: 'RegistartionCustomFormComponent',
        data: {
            selector: 'app-registartion-custom-form'
        }
    },
    {
        path: ':id/:title/registartion-art-form',
        component: 'RegistartionCustomFormComponent',
        data: {
            selector: 'app-registartion-custom-form'
        }
    },
    {
        path: 'registartion-art-form',
        component: 'RegistartionCustomFormComponent',
        data: {
            selector: 'app-registartion-custom-form'
        }
    },
    {
        path: 'abha-card',
        component: 'AbhaCardComponent',
        data: {
            selector: 'app-abha-card'
        }
    },
    {
        path: 'dynamic_dashboard/:identifier',
        component: 'DynamicDashboardComponent',
        data: {
            selector: "app-dynamic-dashboard",
            type: "main",
            foreign_id: "widget_id"
        }
    },
    {
        path: 'uploadcsv',
        component: 'CsvJsonDownloadComponent',
        data: {
            selector: 'app-csv-json-download'
        }
    },
    {
        path: 'external_redirect',
        component: 'ExternalRedirectComponent',
        data: {
            selector: 'external-redirect'
        }
    },
    {
        path: 'archival_data',
        component: 'ArchivalEngineComponent',
        data: {
            selector: 'app-archival-engine',
            resource: 'change_loginId',
            action: 'ADD'

        }
    },
    {
        path: 'ask_ai/:uhId/:id/:is_refer',
        component: 'AvighnaAiComponent',
        data: {
            selector: 'dashboard-avighnaai'
        }
    },
    {
        path: 'online-payment/link',
        component: 'OnlinePaymentGuestComponent',
        data: {
            selector: 'app-online-payment-guest'
        }
    },
    {
        path: 'ai_assessment_result',
        component: 'AvighnaResultComponent',
        data: {
            selector: 'avighna-result'
        }
    },
    {
        path: 'copy-data',
        component: 'CopyComponentComponent',
        data: {
            selector: 'copy-component',
            resource: 'change_loginId',
            action: 'ADD'

        }
    },
    {
        path: 'partial-share-data',
        component: 'CopyComponentComponent',
        data: {
            selector: 'copy-component',
            resource: 'change_loginId',
            action: 'ADD'

        }
    }
]